<template>
    <div class="container-fluid">
        <validation-observer v-slot="{ validate }" slim>
            <form @submit.prevent="store(validate)">
                <app-button class="float-right" :loading="loading" small>
                    {{ $t('Save and add prices') }}
                </app-button>
                <div class="clearfix"></div>
                <vehicle-form :form="form"/>
                <app-button :loading="loading" small>
                    {{ $t('Save and add prices') }}
                </app-button>
            </form>
        </validation-observer>
    </div>
</template>
<script>
import VehicleService from '@services/vehicle.service';
import VehicleForm from './components/Form';

export default {
    data() {
        return {
            form: {
                make_id: null,
                model_id: null,
                drivetrain_id: null,
                type_id: null,
                fuel_id: null,
                transmission_id: null,
                reg_no: null,
                year: null,
                color: {},
                vin: null,
                engine: null,
                odometer: null,
                liability_sum: null,
                bond: null,
                slug: null,
                equipment: {
                    et: '',
                    en:''
                },
                damages: {
                    et: '',
                    en:''
                },
                comments: null,
                images: [],
            },
            loading: false
        };
    },
    methods: {
        store(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    VehicleService.store(this.form).then(res => {
                        this.$toastr.s(this.$t('Saved'));
                        this.loading = true;
                        this.$router.push({name: 'vehicles.show', params: {vehicle_id: res.id}});
                    });
                }
            });
        },
    },
    components: {
        VehicleForm
    }
};
</script>
